// extracted by mini-css-extract-plugin
export default {"description":"AccountLanguageSelect--description--c0edf8","localesList":"AccountLanguageSelect--localesList--d10a60"};